import AbstractProvidedClass from "./AbstractProvidedClass";
import Layer from "./Layer";

export default class LayerCollection extends AbstractProvidedClass {
    collection = {};

    init(collection = []) {
        collection.forEach(l => this.collection[l.id] = new Layer(this.provider, l));
    }

    get(id) {
        return this.collection[id] ?? null;
    }

    addLayer(layer) {
        return this.add(layer);
    }

    remove(id) {
        delete this.collection[id];
    }

    add(layer) {
        if (!layer.id) {
            layer.id = this.generateId(layer.name);
        }
        this.collection[layer.id] = layer;
        return this;
    }

    generateId(name) {
        let base = name.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '');
        let id = base;
        let i = 1;
        while (this.collection[id]) {
            id = `${base}_${i}`;
            i++;
        }
        return id;
    }

    export() {
        return Object.values(this.collection).map(l => l.export());
    }
}
